import React from 'react';
import Header from './Header';
import Generator from './Generator';
import './App.css';

function App() {
  return (
    <div class="content">
      <Header />
      <Generator />
    </div>
  );
}

export default App;
